// extracted by mini-css-extract-plugin
export default {"root":"ScanPage_root__UzwnI"};